import { createSelector } from 'reselect';
import ItemsWithHandoverDataRoadSummaryColumns
  from '../../containers/ItemsWithHandoverDataRoadSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ItemsWithHandoverDataRoadSummaryColumns);
